// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stations_Ffgz2 {
  display: flex;
  height: 100%;
  width: 100%;
  gap: var(--size-padLarge);
  overflow-x: scroll;
  padding: 0 var(--size-padLarge);
}

.content_cDrbH {
  height: 100%;
  width: 100%;
}

.occupied_HvfYF {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/stationCard/StationsCardDataViewer.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".stations {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  gap: var(--size-padLarge);\n  overflow-x: scroll;\n  padding: 0 var(--size-padLarge);\n}\n\n.content {\n  height: 100%;\n  width: 100%;\n}\n\n.occupied {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stations": `stations_Ffgz2`,
	"content": `content_cDrbH`,
	"occupied": `occupied_HvfYF`
};
export default ___CSS_LOADER_EXPORT___;
